import { divide, round } from "mathjs";

export const calculateAverage = (totalValue: number, count: number, roundTo: number | undefined = 2): number => {
  if (!count) return 0;
  return round(divide(totalValue, count), roundTo);
};
